

























import { defineComponent, PropType, ref, toRefs, computed, nextTick } from '@vue/composition-api';
import { SplitTestFormData, AdgroupFormData, CampaignFormData, CreateMode, BaseMinDailyBudget } from '@tt4b/ttam-enums';
import { useAccountCurrency, useAdgroupBudgetValidate } from '@tt4b/ttam-hooks';

import TtamBudget from './../../adgroup/budget/index';

const name = 'ttam-split-test-budget';

export default defineComponent({
  name,
  components: {
    BudgetSet: TtamBudget.TtamBudgetSet,
  },
  props: {
    splitTestFormData: {
      type: Object as PropType<SplitTestFormData>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const budgetSetRef = ref();
    const { campaignData, adgroupData } = toRefs(props);

    const { currencyOption } = TtamBudget.useCommonPropsCurrencyOption();
    const { currencyRatio } = useAccountCurrency();
    const { budgetModeLabel, budgetModeTips } = TtamBudget.useSplitTestPropsText({ adgroupData });

    const { budgetValidator } = useAdgroupBudgetValidate({
      // split test 这个要把最小值 * 2
      minBudgetCalculated: ref(BaseMinDailyBudget * currencyRatio.value * 2),
      campaignFormData: campaignData,
      createMode: ref(CreateMode.CREATE),
    } as any);

    const _budget = computed({
      get() {
        return props.splitTestFormData.budget;
      },
      set(val: string) {
        emit('change', val);

        nextTick(() => {
          budgetSetRef.value?.validate?.('custom');
        });
      },
    });

    return {
      name,
      budgetSetRef,
      _budget,
      budgetModeLabel,
      budgetModeTips,
      currencyOption,
      budgetValidator,
    };
  },
});
